const ROUTES = {
    HOME: "/",
    ABOUT: "/about/",
    CONTACT: "/contact/",
    SERVICES: "/services/",
    SERASA: "/serasa/",
}

export default ROUTES;